// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"bfb91394","93":"cdfd91eb","165":"68a05c1d","171":"487b91f2","415":"6cd8795f","494":"771861d5","796":"218a5d6a","821":"29bf66ed"}[chunkId] + ".chunk.js";
};